const renderTypes = {
    advancedSearchLink: 'advancedSearchLink',
    groupHeader: 'groupHeader',
    placeholder: 'placeholder',
    staticParentHeader: 'staticParentHeader',
    text: 'text',
    dateTime: 'dateTime',
};

export default renderTypes;
